import(/* webpackMode: "eager" */ "__barrel_optimize__?names=ConfigProvider!=!/root/iyiwutrade/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/@ant-design/v5-patch-for-react-19/es/index.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyiwutrade/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AntdStyleProvider"] */ "/root/iyiwutrade/src/context/AntdStyleProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["DataProvider"] */ "/root/iyiwutrade/src/context/hooks/DataProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollController"] */ "/root/iyiwutrade/src/lib/scrollController.js");
